import { types } from 'mobx-state-tree';

import MobileNavigationTab, {
  MobileNavigationTabType,
} from '../../types/MobileNavigationTab';
import { blockScroll, unblockScroll } from '../../util/dom';
import Modal from './Modal';

const NavigationOffCanvas = Modal.named('NavigationOffCanvas')
  .props({
    activeTab: types.optional(
      MobileNavigationTabType,
      MobileNavigationTab.PRODUCTS
    ),
    // Same Save-in-flight guard as MobileNavigation: Regional Settings can
    // open from the desktop Tuotteet off-canvas and must keep the panel open
    // until Save finishes so failures can still surface.
    closeBlocked: types.optional(types.boolean, false),
  })
  .actions((self) => {
    return {
      selectTab(tab) {
        if (self.closeBlocked) {
          return;
        }
        self.activeTab = tab;
      },
      setCloseBlocked(blocked) {
        self.closeBlocked = Boolean(blocked);
      },
      close() {
        if (self.closeBlocked) {
          return;
        }
        self.isOpen = false;
        unblockScroll();
      },
      open() {
        self.isOpen = true;
        blockScroll();
      },
      toggle(useBlockScroll = true, state = null) {
        const nextIsOpen = state == null ? !self.isOpen : Boolean(state);
        if (self.closeBlocked && self.isOpen && !nextIsOpen) {
          return;
        }
        self.isOpen = nextIsOpen;
        if (useBlockScroll) {
          if (self.isOpen) {
            blockScroll();
          } else {
            unblockScroll();
          }
        }
      },
    };
  });

export default NavigationOffCanvas;
